import React from "react";
import { connect } from "react-redux";
import Request from "../../request";
import ListDrawer from './list';
import './css/frontOfficeDashboard.css';
import { Row, Col, Card, Button, notification } from "antd";


import {
    FaUserClock, FaRegSadCry, FaPhoneSlash, FaExclamationTriangle,
    FaSkull, FaUsers, FaPhoneAlt, FaPauseCircle, FaRegMeh, FaQuestionCircle, FaBriefcase, FaUserTimes,
    FaHandPointRight, FaCheckDouble, FaHandsHelping, FaRegSmileBeam, FaExchangeAlt, FaRupeeSign
} from "react-icons/fa"
import ReceiptsView from '../../components/DocumentViews/receiptsView'

const followUpStatusMeta = {
    "Not Interested": {
        icon: <FaRegSadCry />,
        color: "bg-color-red",
    },
    "Didn't Pick up Call": {
        icon: <FaPhoneSlash />,
        color: "bg-color-orange",
    },
    "Number out of service": {
        icon: <FaExclamationTriangle />,
        color: "bg-color-dark-red",
    },
    "Dead": {
        icon: <FaSkull />,
        color: "bg-color-dark-red",
    },
    "Active": {
        icon: <FaUsers />,
        color: "bg-color-blue",
    },
    "Busy, Call Later": {
        icon: <FaUserClock />,
        color: "bg-color-yellow",
    },
    "Number not connected": {
        icon: <FaPhoneAlt />,
        color: "bg-color-grey",
    },
    "Out Of town": {
        icon: <FaPauseCircle />,
        color: "bg-color-orange",
    },
    "Cold": {
        icon: <FaRegMeh />,
        color: "bg-color-grey",
    },
    "Untouched": {
        icon: <FaQuestionCircle />,
        color: "bg-color-grey",
    },
    "Job": {
        icon: <FaBriefcase />,
        color: "bg-color-blue",
    },
    "OBD Call - Not interested": {
        icon: <FaUserTimes />,
        color: "bg-color-red",
    },
    "Another query": {
        icon: <FaHandPointRight />,
        color: "bg-color-blue",
    },
    "Commission Done": {
        icon: <FaCheckDouble />,
        color: "bg-color-green",
    },
    "Spouse Visa": {
        icon: <FaHandsHelping />,
        color: "bg-color-blue",
    },
    "OBD Call - Interested": {
        icon: <FaRegSmileBeam />,
        color: "bg-color-green",
    },
    "Final Decision Pending": {
        icon: <FaExclamationTriangle />,
        color: "bg-color-yellow",
    },
    "B2B": {
        icon: <FaExchangeAlt />,
        color: "bg-color-blue",
    }
};


class RegistrationDashboard extends React.Component {
    state = {
        newStudents: {
            "Today": { total: 0, arr: [] },
            "Yesterday": { total: 0, arr: [] },
            "Week": { total: 0, arr: [] },
            "Month": { total: 0, arr: [] },
        },
        consultancyReceived: {
            "Today": { total: 0, arr: [] },
            "Yesterday": { total: 0, arr: [] },
            "Week": { total: 0, arr: [] },
            "Month": { total: 0, arr: [] },
        },
        outStandingConsultancy: {
            total: 0,
            arr: [],
            amount: 0
        },
        followupsCount: {
            "Not Interested": { total: 0, arr: [] },
            "Didn't Pick up Call": { total: 0, arr: [] },
            "Number out of service": { total: 0, arr: [] },
            "Dead": { total: 0, arr: [] },
            "Active": { total: 0, arr: [] },
            "Busy, Call Later": { total: 0, arr: [] },
            "Number not connected": { total: 0, arr: [] },
            "Out Of town": { total: 0, arr: [] },
            "Cold": { total: 0, arr: [] },
            "Untouched": { total: 0, arr: [] },
            "Job": { total: 0, arr: [] },
            "OBD Call - Not interested": { total: 0, arr: [] },
            "Another query": { total: 0, arr: [] },
            "Commission Done": { total: 0, arr: [] },
            "Spouse Visa": { total: 0, arr: [] },
            "OBD Call - Interested": { total: 0, arr: [] },
            "Final Decision Pending": { total: 0, arr: [] },
            "B2B": { total: 0, arr: [] },
        },
        drawer: false,
        drawerParam: {},
        todayRegistrationsReceipts: [],
        showAccountPaymentDrawar: false,
        receiptsCount: {
            submittedCount: 0,
            approvedCount: 0
        }
    }


    mergeStatus(defaultObj, apiObj = {}) {
        let result = { ...defaultObj };

        Object.keys(apiObj).forEach(key => {
            if (result[key]) {
                result[key] = {
                    ...result[key],
                    ...apiObj[key]
                };
            }
        });

        return result;
    }


    loadAllApis = async (params = {}) => {

        let response = await Request.getRegistrationDashboardData();

        this.setState({
            ...response,
            followupsCount: this.mergeStatus(this.state.followupsCount, response.followupsCount),
            newStudents: this.mergeStatus(this.state.newStudents, response.newStudents),
            consultancyReceived: this.mergeStatus(this.state.consultancyReceived, response.consultancyReceived),
        });
        Request.getTodayRegistrationsReceipts().then((response) => {
            this.setState({
                todayRegistrationsReceipts: response.data.receipts,
                receiptsCount: {
                    submittedCount: response.data.todaySubmittedCount,
                    approvedCount: response.data.todayApprovedCount
                }
            })
        });
    };


    componentDidMount() {
        this.loadAllApis();
    }

    submitTodayFees = async (data, department) => {
        let response = await Request.submitTodaysPayments({});
        if (response.success === true) {
            notification.success({
                message: "Submitted Successfully",
            });
            this.loadAllApis();
        } else {
            notification.error({ message: "Try again" });
        }
    }

    viewAccountPaymentReceipt = () => {
        this.setState({
            showAccountPaymentDrawar: true
        })
    }

    closeDocument = () => {
        this.setState({ showAccountPaymentDrawar: false });
    }

    exportExcelTodaysReceipts = async () => {
        let response = await Request.exportTodaysPayments();
        if (!response.error) {
            window.location.href = response.url;
        }
    }

    render() {
        let { drawer, drawerParam, followupsCount, todayRegistrationsReceipts, showAccountPaymentDrawar, receiptsCount } = this.state;
        let todaysPaymentHtml = [];
        let totalPaidToday = 0;
        todayRegistrationsReceipts.map((todayRegistrationsReceipt, index) => {
            totalPaidToday += parseFloat(todayRegistrationsReceipt.totalAmount);
            todaysPaymentHtml.push(
                <tr key={index}>
                    <td>{todayRegistrationsReceipt.amountType}</td>
                    <td>{todayRegistrationsReceipt.studentId}</td>
                    <td>{todayRegistrationsReceipt.studentName}</td>
                    <td>{todayRegistrationsReceipt.dob}</td>
                    <td>{todayRegistrationsReceipt.receiptNumber}</td>
                    <td><FaRupeeSign />{todayRegistrationsReceipt.totalAmount}</td>
                    <td>{todayRegistrationsReceipt.paymentType}</td>
                    <td>{todayRegistrationsReceipt.remarks}</td>
                    <td>{todayRegistrationsReceipt.submittedDate && todayRegistrationsReceipt.approvedDate ? 'Approved' : (todayRegistrationsReceipt.submittedDate ? 'Submitted' : 'Pending')}</td>
                </tr>
            )
        })
        let showSubmittedButton = true;
        if (this.state.todayRegistrationsReceipts && this.state.todayRegistrationsReceipts.length === this.state.receiptsCount.submittedCount) {
            showSubmittedButton = false;
        }
        return (
            <div className="fod-container">
                {
                    showAccountPaymentDrawar ?
                        <ReceiptsView onClose={this.closeDocument} />
                        : null
                }
                {drawer && <ListDrawer param={drawerParam} onClose={() => this.setState({ drawer: false })} />}
                <Row className="fod-row">
                    <Col span={8}>
                        <Card title="New Students" style={{ marginTop: 15 }}>
                            {Object.keys(this.state.newStudents).map((key) => {
                                const item = this.state.newStudents[key];
                                return (
                                    <div
                                        key={key}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "8px 0",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "15px"
                                        }}
                                    >
                                        {/* Left Side: Title */}
                                        <span title={key}>{key}</span>

                                        {/* Right Side: Clickable Count */}
                                        <span
                                            style={{ color: "#1890ff", cursor: "pointer", fontWeight: 600 }}
                                            onClick={() =>
                                                this.setState({
                                                    drawer: true,
                                                    drawerParam: {
                                                        title: key + " Students",
                                                        arr: item.arr,
                                                        count: item.total
                                                    }
                                                })
                                            }
                                        >
                                            {item.total}
                                        </span>
                                    </div>
                                );
                            })}
                        </Card>

                    </Col>
                    <Col span={8}>
                        <Card title="Consultancy Received" style={{ marginTop: 15 }}>
                            {Object.keys(this.state.consultancyReceived).map((key) => {
                                const item = this.state.consultancyReceived[key];
                                return (
                                    <div
                                        key={key}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "8px 0",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "15px"
                                        }}
                                    >
                                        {/* Left Side: Title */}
                                        <span title={key}>{key}</span>

                                        {/* Right Side: Clickable Count */}
                                        <span
                                            style={{ color: "#1890ff", cursor: "pointer", fontWeight: 600 }}
                                            onClick={() =>
                                                this.setState({
                                                    drawer: true,
                                                    drawerParam: {
                                                        title: key + " Students",
                                                        arr: item.arr,
                                                        count: item.total
                                                    }
                                                })
                                            }
                                        >
                                            {item.total}
                                        </span>
                                    </div>
                                );
                            })}
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card title="Outstanding Consultancy" style={{ marginTop: 15 }}>
                            {this.state.outStandingConsultancy && (
                                <div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "8px 0",
                                        borderBottom: "1px solid #eee",
                                        fontSize: "15px"
                                    }}>
                                        <span>Students</span>
                                        <span
                                            style={{ color: "#1890ff", cursor: "pointer", fontWeight: 600 }}
                                            onClick={() =>
                                                this.setState({
                                                    drawer: true,
                                                    drawerParam: {
                                                        title: "Outstanding Consultancy Students",
                                                        arr: this.state.outStandingConsultancy.arr,
                                                        count: this.state.outStandingConsultancy.total
                                                    }
                                                })
                                            }
                                        >
                                            {this.state.outStandingConsultancy.total}
                                        </span>
                                    </div>

                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "8px 0",
                                        borderBottom: "1px solid #eee",
                                        fontSize: "15px"
                                    }}>
                                        <span>Amount</span>
                                        <span>{this.state.outStandingConsultancy.amount}</span>
                                    </div>
                                </div>
                            )}
                        </Card>
                    </Col>
                </Row>

                <Row>
                    {
                        todayRegistrationsReceipts && todayRegistrationsReceipts.length > 0 ?
                            <Col span={24} style={{ marginTop: '20px' }}>
                                <h3>{`Today's Registration Fees : ${todayRegistrationsReceipts.length}`}</h3>
                                <table cellPadding={10} className="student-custom-table improved-table">
                                    <thead>
                                        <tr>
                                            <th>Amount Type</th>
                                            <th>Student ID</th>
                                            <th>Student Name</th>
                                            <th>DOB</th>
                                            <th>Receipt Number</th>
                                            <th>Received Amount</th>
                                            <th>Payment Type</th>
                                            <th>Remarks</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {todaysPaymentHtml}
                                    </tbody>

                                    <tfoot>
                                        <tr className="footer-total">
                                            <td colSpan={5} style={{ textAlign: "right", fontWeight: 600 }}>Total:</td>
                                            <td>
                                                <FaRupeeSign /> {totalPaidToday}
                                            </td>
                                            <td colSpan={3}></td>
                                        </tr>

                                        {showSubmittedButton ? (
                                            <tr className="footer-action">
                                                <td style={{ fontWeight: 600 }}>Submit Today's Amount</td>
                                                <td colSpan={4}></td>
                                                <td>
                                                    <Button
                                                        type='primary'
                                                        onClick={() => {
                                                            this.submitTodayFees(todayRegistrationsReceipts, 'tpsc');
                                                        }}
                                                    >
                                                        Submit
                                                    </Button>
                                                </td>
                                                <td colSpan={3}></td>
                                            </tr>
                                        ) : (
                                            <tr className="footer-action">
                                                <td style={{ fontWeight: 600 }}>
                                                    {receiptsCount.submittedCount > 0 && receiptsCount.approvedCount > 0
                                                        ? "Request Approved"
                                                        : "Already Submitted"
                                                    }
                                                </td>

                                                <td colSpan={4}></td>

                                                <td style={{ display: "flex", gap: "10px" }}>
                                                    {receiptsCount.submittedCount > 0 && (
                                                        <Button onClick={() => this.viewAccountPaymentReceipt()} type="default">
                                                            Print
                                                        </Button>
                                                    )}

                                                    {receiptsCount.submittedCount > 0 && (
                                                        <Button onClick={() => this.exportExcelTodaysReceipts()} type="default">
                                                            Export Excel
                                                        </Button>
                                                    )}
                                                </td>

                                                <td colSpan={3}></td>
                                            </tr>
                                        )}
                                    </tfoot>
                                </table>

                            </Col>
                            : null
                    }
                </Row>

                <Card title="Follow Ups" style={{ marginTop: 10 }}>
                    <Row className="fod-row">

                        {Object.keys(followupsCount).map((key) => {
                            const item = followupsCount[key];
                            const meta = followUpStatusMeta[key] || {};

                            return (
                                <Col span={6} key={key}>
                                    <div className="info-box glass">

                                        <span className={`info-box-icon ${meta.color} elevation-1`}>
                                            {meta.icon}
                                        </span>

                                        <div className="info-box-content">
                                            <span className="info-box-text" title={key}>{key}</span>

                                            <span className="info-box-number">
                                                <a
                                                    onClick={() =>
                                                        this.setState({
                                                            drawer: true,
                                                            drawerParam: {
                                                                title: key,
                                                                arr: item.arr,
                                                                count: item.total
                                                            }
                                                        })
                                                    }
                                                >
                                                    {item.total}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}

                    </Row>
                </Card>
            </div>
        )
    }
}


const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (RegistrationDashboard)

